import styles from "./styles.scss";
import { FC } from "react";
import clsx from "clsx";
import { Button, ButtonSize, ButtonVariant } from "@/components/button";
import { ErrorScreenProps } from "./types";
import { Lock3 } from "@/assets/icons";

export const UnAuthorizedErrorScreen: FC<ErrorScreenProps> = ({
  onButtonClick,
}) => {
  return (
    <div className={clsx(styles.wrapper)}>
      <div className={clsx(styles.icon)}>
        <img
          src={Lock3}
          alt="lock"
          style={{ width: "100px", height: "100px" }}
        />
      </div>

      <div className={clsx(styles.contentWrapper)}>
        <div className={clsx(styles.title)}>
          You don&apos;t have permission to access this portal.
        </div>

        <div className={clsx(styles.subtitle)}>
          Your email has to be registered under your company profile in SAP
          Ariba network to access this portal.
        </div>

        <Button
          className={clsx(styles.errorScreenButton, styles.button)}
          onClick={onButtonClick}
          variant={ButtonVariant.Primary}
          size={ButtonSize.Small}
        >
          Logout
        </Button>
      </div>
    </div>
  );
};
